import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'
import GettingStarted from '@segment/templates/GettingStarted'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import TemplatesToGetStarted from './components/TemplatesToGetStarted/TemplatesToGetStarted'

import CustomSources from './components/CustomSources'
import { CustomDestinations } from './components/CustomDestinations/CustomDestinations'
import OrchestrateAndOptimize from './components/OrchestrateAndOptimize'
import DevelopOnSegment from './components/DevelopOnSegment'
import FeatureBoxGroup from './components/FeatureBoxGroup'
import LogoCarousel from './components/LogoCarousel'

import ogImagePng from './assets/OgFunctions.png'

const FunctionsView = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Functions | Twilio Segment"
        pageDescription="With just a few lines of JavaScript, Functions allows you to build any Twilio Segment integration with no additional infrastructure required. See how it works."
        pageOG={ogImagePng}
        bodyBackground={theme.palette.neutrals.white[100]}
      >
        <Main>
          <Navigation />
          <Hero />
          <LogoCarousel />
          <CustomSources />
          <CustomDestinations />
          <OrchestrateAndOptimize />
          <DevelopOnSegment />
          <FeatureBoxGroup />
          <TemplatesToGetStarted />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default FunctionsView
